import React from "react";
import { Helmet } from "react-helmet";
import config from "../../config";

const PageMetaTagTitle = ({ title, appName = config.appName, ...rest }) => {
  const appNamePrefix = appName ? `${appName} - ` : "";
  const pageTitle = title ? `${appNamePrefix}${title}` : appName;

  return (
    <Helmet {...rest}>
      <title>{pageTitle}</title>
    </Helmet>
  );
};

export default PageMetaTagTitle;
